import Vue from 'vue';

import sentry from '@/config/sentry';

import '@/config/font-awesome';

import router from './router';

import App from './App.vue';

sentry(router);

Vue.config.productionTip = false;

const id = process.env.VUE_APP_ROOT_ID;

if (document.getElementById(id)) {
  new Vue({
    render: h => h(App),
    router,
  }).$mount(`#${id}`);
}
